import { render, staticRenderFns } from "./RelationshipField.vue?vue&type=template&id=1a31f3a8"
import script from "./RelationshipField.vue?vue&type=script&lang=js"
export * from "./RelationshipField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports